/**
 * Fora de serviço declarado — GUPM-307. TS puro.
 *
 * Instrumento retirado de campo continua, sem isto, sendo tratado como se estivesse
 * medindo. O estado que faltava é uma DECLARAÇÃO, não uma inferência: silêncio inferido
 * tem de abrir TARP de perda de sinal (o `TIL-05` do GUPM-303), silêncio declarado não.
 * Os dois se apresentam como `isOnline === false` — a declaração é o único fato que os
 * separa.
 *
 * Módulo próprio, e não um `if` dentro do `nivel-exibido`, porque a pergunta "este
 * instrumento está em serviço?" é anterior a "que cor ele tem" e é feita também pela
 * ingestão (que não tem nada a ver com cor).
 */

/** Forma mínima para responder se o instrumento está fora de serviço. */
export interface ForaDeServicoLike {
  foraDeServicoDesde: Date | null;
}

/**
 * O instrumento está declarado fora de serviço?
 *
 * **Não olha `modoLeitura`** — e isso é a regra, não um esquecimento. `modo_leitura` vem
 * do campo `manual` do inventário GPX e descreve como a leitura é COLETADA (alguém lê em
 * campo e lança no sistema do fornecedor), não que ela deixe de chegar pela API: o
 * `TIL-02` da Barragem B é `manual` e publica 111 leituras por dia. Usar aquele campo aqui
 * desligaria a detecção de perda de sinal de um tiltímetro ATIVO na barragem prioritária —
 * o sensor de ruptura.
 */
export function foraDeServico(inst: ForaDeServicoLike): boolean {
  return inst.foraDeServicoDesde !== null;
}

/**
 * Texto do selo de fora de serviço: `"Fora de serviço desde 20/08"`.
 *
 * A data é obrigatória no rótulo. "Fora de serviço" sozinho não responde a pergunta que o
 * plantonista faz olhando um valor velho na tela — *desde quando?* — e é ela que separa
 * "saiu ontem" de "saiu há um mês".
 */
export function rotuloForaDeServico(desde: Date): string {
  const dia = String(desde.getDate()).padStart(2, '0');
  const mes = String(desde.getMonth() + 1).padStart(2, '0');
  return `Fora de serviço desde ${dia}/${mes}`;
}
